import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import CurrentApplicationFlow from '@banking/api/services/current-application-flow';
import { ROUTE_FOR_TERMINAL_STATUS } from '@banking/savings-onboarding-app/utils/signup/route-for-application-status';
import type RouterService from '@ember/routing/router-service';

export default class EnterIdentityInfo extends Route {
  @service currentApplicationFlow!: CurrentApplicationFlow;
  @service router!: RouterService;

  redirect() {
    if (this.currentApplicationFlow?.status) {
      const route =
        ROUTE_FOR_TERMINAL_STATUS[this.currentApplicationFlow.status];
      if (route) {
        this.router.transitionTo(route);
      }
    }
  }
}
